import { RowDataBannerWeb } from "../../components/BannerWebPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the BannerWebTable factory
 */
class BannerWebRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/banner-web/read-range"
        this.accessData = "banners"
    }

    create(banner: any): RowDataBannerWeb {
        const rowDataBanner: RowDataBannerWeb = {
            id: banner.id,
            title: banner.title,
            descs: banner.descs,
            img: banner.img,
            imgMobile: banner.imgMobile,
            buttonTitle: banner.buttonTitle,
            newTab: banner.newTab,
            darkMode: banner.darkMode,
            // color: banner.color,
            type: banner.type,
            route: banner.route,
            show: banner.show,
            action: "",
        };
        return rowDataBanner;
    }
}

let bannerWebRow: BannerWebRow | null = null;

export default function getBannerWebRow(): BannerWebRow {
    if (bannerWebRow === null)
        bannerWebRow = new BannerWebRow()
    return bannerWebRow
}